import { render, staticRenderFns } from "./MobileChallengeForfeitActionMenu.vue?vue&type=template&id=1f09873c&scoped=true&lang=pug&"
import script from "./MobileChallengeForfeitActionMenu.vue?vue&type=script&lang=js&"
export * from "./MobileChallengeForfeitActionMenu.vue?vue&type=script&lang=js&"
import style0 from "./MobileChallengeForfeitActionMenu.vue?vue&type=style&index=0&id=1f09873c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f09873c",
  null
  
)

export default component.exports